import { ForexState } from "./interface";

export default <ForexState> {
	draftsCount: 0,
	templatesCount: 0,
	courseBuy: [],
	courseSell: []
}